// Shared Manager/Partner role toggle used across Billing Review, Stale Jobs,
// and Client Contact sections. Pill-shaped two-option slider with a thumb that
// animates between halves. Replaces the older two-button .role-btn / .rt-role-btn
// pattern.

import React from 'react';
import './RoleToggle.css';

// `withApprovals` adds a third option (admins only) that opens the Billing Approvals queue.
export default function RoleToggle({ role, onChange, disabled, withApprovals = false }) {
  const handleClick = (next) => {
    if (disabled || next === role) return;
    onChange(next);
  };
  return (
    <div className="role-toggle">
      <span className="role-toggle-label">Viewing as:</span>
      <div
        className="role-toggle-track"
        data-active={role}
        data-count={withApprovals ? 3 : 2}
        aria-disabled={disabled ? 'true' : 'false'}
        role="radiogroup"
      >
        <button
          type="button"
          className="role-toggle-option"
          onClick={() => handleClick('manager')}
          disabled={disabled}
          role="radio"
          aria-checked={role === 'manager'}
        >
          Manager
        </button>
        <button
          type="button"
          className="role-toggle-option"
          onClick={() => handleClick('partner')}
          disabled={disabled}
          role="radio"
          aria-checked={role === 'partner'}
        >
          Partner
        </button>
        {withApprovals && (
          <button
            type="button"
            className="role-toggle-option"
            onClick={() => handleClick('approvals')}
            disabled={disabled}
            role="radio"
            aria-checked={role === 'approvals'}
          >
            Approvals
          </button>
        )}
        <span className="role-toggle-thumb" aria-hidden="true" />
      </div>
    </div>
  );
}
